import React, { useState } from "react";
import Swal from "sweetalert2";

export default function ScanDismantleUser({ token, onSuccess }) {
  const [loading, setLoading] = useState(false);

  const handleScan = async () => {
    const confirm = await Swal.fire({
      title: "Scan Dismantle Users?",
      text: "Proses ini akan mencari user yang harus dipindahkan ke dismantle_list",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Lanjutkan",
      cancelButtonText: "Batal",
    });

    if (!confirm.isConfirmed) return;

    try {
      setLoading(true);

      const res = await fetch("https://api.wifikamu.my.id/scan-dismantle-users", {
        method: "GET",
        headers: {
          Authorization: token,
        },
      });

      const result = await res.json();

      if (result?.success) {
        await Swal.fire({
          icon: "success",
          title: "Berhasil!",
          text: result.message || "Proses scan selesai.",
        });

        if (onSuccess) onSuccess(); // refresh data halaman utama
      } else {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: result.message || "Terjadi kesalahan.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Tidak bisa terhubung ke server",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleScan}
      disabled={loading}
      className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-300 dark:bg-blue-500 dark:hover:bg-blue-600"
    >
      {loading ? "Scanning..." : "Scan Dismantle Users"}
    </button>
  );
}
